import styled, { ITheme } from '../../../../theme'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'

const TimeWrapper = styled.div<IWithSize & {subError?: boolean}>`
  height: auto;
  background-color: ${(props: any) => props.subError? '#F7D8D8':props.theme.colors.palette.paleGrey};
  display: flex;
  justify-content: center;
  padding: 10px ${({ size }) => (size ? 18 * size : 18)}px;
  font-family: 'Open Sans', sans-serif;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  font-weight: normal;
  flex-direction: column;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.1px;
  text-align: left;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
`
export default TimeWrapper
